export class BaseUrlProvider {
    public static getBaseUrl(): string {
        return process.env.VUE_APP_API_SERVER;
    }
}
